import { Suspense } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import BlogDetailHero from '../components/BlogDetailHero';
import BlogDetailContent from '../components/BlogDetailContent';
import { useSEO } from '../../../utils/seo';

const CRMSystemBlog = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'CRM Sistemi Neden Her Acentenin Olmalı? - Sigorta360 Blog',
    description: 'Sigorta acenteleri için CRM sisteminin önemi. Müşteri yönetimi, zaman tasarrufu, satış artışı ve otomasyon avantajları hakkında detaylı bilgi.',
    keywords: 'CRM sistemi, müşteri yönetimi, sigorta CRM, otomasyon, müşteri takip',
    canonical: `${siteUrl}/akademi/crm-sistemi-neden-her-acentenin-olmali`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: 'CRM Sistemi Neden Her Acentenin Olmalı?',
      description: 'Sigorta acenteleri için CRM sisteminin önemi ve faydaları',
      author: {
        '@type': 'Organization',
        name: 'Sigorta360 Ekibi'
      },
      publisher: {
        '@type': 'Organization',
        name: 'Sigorta360',
        logo: {
          '@type': 'ImageObject',
          url: `${siteUrl}/logo.png`
        }
      },
      datePublished: '2025-01-05',
      dateModified: '2025-01-05',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': `${siteUrl}/akademi/crm-sistemi-neden-her-acentenin-olmali`
      }
    }
  });

  const blogData = {
    title: 'CRM Sistemi Neden Her Acentenin Olmalı?',
    category: 'CRM & Otomasyon',
    date: '5 Ocak 2025',
    readTime: '7 dk',
    author: 'Sigorota360 Ekibi',
    image: 'https://public.readdy.ai/ai/img_res/ff162bd16f8bc5eedc48304fbe16364b.jpg',
    content: [
      {
        type: 'paragraph',
        text: 'Müşteri İlişkileri Yönetimi (CRM) sistemleri, modern sigorta acenteleri için artık bir lüks değil, zorunluluk haline geldi. Peki CRM sistemi tam olarak nedir ve neden her acentenin kullanması gerekir?',
      },
      {
        type: 'heading',
        text: 'CRM Nedir?',
      },
      {
        type: 'paragraph',
        text: 'CRM, müşteri bilgilerini merkezi bir sistemde toplayan, müşteri etkileşimlerini takip eden ve satış süreçlerini otomatikleştiren bir yazılımdır. Tüm müşteri verileriniz, iletişim geçmişiniz ve satış fırsatlarınız tek bir platformda toplanır.',
      },
      {
        type: 'heading',
        text: 'Zaman Tasarrufu Sağlar',
      },
      {
        type: 'paragraph',
        text: 'Manuel veri girişi, Excel tabloları ve dağınık notlar yerine, tüm bilgileriniz otomatik olarak CRM sisteminde saklanır. Müşteri bilgilerine saniyeler içinde ulaşabilir, geçmiş görüşmeleri görebilir ve hızlı aksiyon alabilirsiniz. Bu, günde saatler kazandırır.',
      },
      {
        type: 'heading',
        text: 'Müşteri Memnuniyetini Artırır',
      },
      {
        type: 'paragraph',
        text: 'CRM ile müşterilerinizin tüm geçmişini görebilirsiniz. Hangi poliçeleri var? Ne zaman yenileme zamanı? Daha önce hangi konularda görüştünüz? Bu bilgilerle daha kişiselleştirilmiş ve profesyonel hizmet sunabilirsiniz.',
      },
      {
        type: 'heading',
        text: 'Satışları Artırır',
      },
      {
        type: 'paragraph',
        text: 'CRM sistemleri, satış fırsatlarını takip etmenizi ve hiçbir potansiyel müşteriyi kaçırmamanızı sağlar. Otomatik hatırlatıcılar, takip görevleri ve satış hunisi yönetimi ile dönüşüm oranlarınızı önemli ölçüde artırabilirsiniz.',
      },
      {
        type: 'heading',
        text: 'Raporlama ve Analiz',
      },
      {
        type: 'paragraph',
        text: 'Hangi ürünler daha çok satılıyor? Hangi pazarlama kanalı daha etkili? Ekip performansı nasıl? CRM sistemleri detaylı raporlar sunarak, veri odaklı kararlar almanızı sağlar.',
      },
      {
        type: 'heading',
        text: 'Otomasyon Gücü',
      },
      {
        type: 'paragraph',
        text: 'Poliçe yenileme hatırlatmaları, doğum günü mesajları, takip e-postaları gibi rutin işleri otomatikleştirebilirsiniz. Bu sayede ekibiniz daha değerli işlere odaklanabilir.',
      },
      {
        type: 'paragraph',
        text: 'Sonuç olarak, CRM sistemi kullanmayan bir sigorta acentesi, rakiplerine karşı ciddi dezavantajda demektir. Müşteri ilişkilerinizi güçlendirmek, satışlarınızı artırmak ve işinizi büyütmek istiyorsanız, CRM yatırımı kaçınılmazdır.',
      },
    ],
  };

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen bg-white">
        <Header />
        <BlogDetailHero data={blogData} />
        <BlogDetailContent data={blogData} />
        <Footer />
      </div>
    </Suspense>
  );
};

export default CRMSystemBlog;
